import {
  Modal,
  Divider,
  Button,
  Spinner,
  useSnackbar,
  Skeleton,
} from "@livingdesign/react";
import React, { useEffect, useState } from "react";
import { ReleaseNotesModalStyles } from "./ReleaseNotesModal.styles";
import { OK } from "../../../constants/actionButtons";
import { useDispatch, useSelector } from "react-redux";
import { setShowReleaseNotes } from "../../../store/actions/commonActions";
import moment from "moment";
import { NODE_JS_URL } from "../../../constants/baseURLs";
import { postService } from "../../../axios/axios";
import { getErrorMessage } from "../../../helpers/utils";

/**
 * ModalActions
 */
const ModalActions = (props) => {
  const { onOkClick } = props;
  return (
    <Button
      variant="primary"
      size="small"
      data-testid="ok-btn"
      id="ok-btn"
      onClick={onOkClick}
    >
      {OK}
    </Button>
  );
};

const ReleaseNotesModal = () => {
  const classes = ReleaseNotesModalStyles();
  const releaseNotesData = useSelector((state) => state?.user?.releaseNotes?.releaseNotesData);
  const dispatch = useDispatch();
  const showReleaseNotesModal = useSelector((state) => state?.common?.showReleaseNotesModal);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const { addSnack } = useSnackbar();
  const [videoUrl, setVideoUrl] = useState();
  const [audioUrl, setAudioUrl] = useState();
  const [videoLoading, setVideoLoading] = useState(false);
  const [audioLoading, setAudioLoading] = useState(false);

  // dispatch(setShowReleaseNotes(true))

  useEffect(() => {
    if (localStorage.getItem("releaseNotesData") === null) {
      localStorage.setItem("releaseNotesData", releaseNotesData?.releaseVersion)
      dispatch(setShowReleaseNotes(true))
    } else {
      const lastReleaseNoteVersion = localStorage.getItem('releaseNotesData');
      if (lastReleaseNoteVersion !== releaseNotesData?.releaseVersion &&
        moment(releaseNotesData?.expiry).isAfter(moment(new Date()))) {
        dispatch(setShowReleaseNotes(true))
        localStorage.setItem("releaseNotesData", releaseNotesData?.releaseVersion)
      } else {
        dispatch(setShowReleaseNotes(false))
      }
    }
  }, [releaseNotesData])

  const getUrl = (fileId, setUrl) => {
    setDownloadLoading(true);
    postService(NODE_JS_URL, `/share?fileId=${fileId}&version=1`, { isContent: true })
      .then((res) => {
        setUrl(res?.data?.url);
        setDownloadLoading(false);
      }
      )
      .catch((error) => {
        addSnack({
          message: getErrorMessage(error)
        })
        setDownloadLoading(false);
      })
  }

  // Load video/audio URLs when component mounts and releaseNotesData is available
  useEffect(() => {
    if (releaseNotesData?.content) {
      releaseNotesData.content.forEach((item) => {
        if (item?.isVideo && item?.urlId && !videoLoading) {
          setVideoUrl(item?.urlId)
          setVideoLoading(false);
        }
        if (item?.isAudio && item?.urlId && !audioLoading) {
          getUrl(item.urlId, setAudioUrl);
          setAudioLoading(false);
        }
      });
    }
  }, [releaseNotesData, videoLoading, audioLoading]);

  const renderVideo = () => {
    if (videoLoading) {
      return <Skeleton height="18px" variant="rectangle" />;
    }
    return videoUrl ? <iframe src={videoUrl} frameBorder="0" allowFullScreen className={classes.video}></iframe> : null;
  };

  const renderAudio = () => {
    if (audioLoading) {
      return <Skeleton height="18px" variant="rectangle" />;
    }
    return audioUrl ? (
      <audio controls className={classes.audio}>
        <source src={audioUrl} />
      </audio>
    ) : null;
  };

  return (
    <Modal
      data-testid="delete-Modal"
      isOpen={showReleaseNotesModal}
      onClose={() => dispatch(setShowReleaseNotes(false))}
      size="medium"
      title={"Release Notes"}
      actions={<ModalActions onOkClick={() => dispatch(setShowReleaseNotes(false))} />}
    >
      <div className={classes.wrapperDiv}>
        <Divider />
        {releaseNotesData?.content?.map((item, index) => (
          <div key={`release-note-${index}-${item?.heading}`}>
            <h4 className={classes.subTitle}>{item?.heading}</h4>
            {item?.content?.map((row, rowIndex) => (
              <ul className={classes.list} key={`content-${index}-${rowIndex}`}>
                <strong className={classes.bullets}>&bull;</strong> {row}
              </ul>
            ))}

            {item?.note && (
              <p className={classes.note}>
                <strong>Note:</strong> {item.note}
              </p>
            )}

            {item?.isVideo && (
              <div className={classes.videoContainer}>
                {renderVideo()}
              </div>
            )}
            {item?.isAudio && renderAudio()}
          </div>
        ))}
      </div>
    </Modal >
  );
};

export default ReleaseNotesModal;